import {
  consignmentStates,
  deliveryFailedStates,
  miscStates,
  pickupSuccessStates,
  deliverySuccessStates,
  riderAssignedStates,
  pickupFailedStates,
  closedStates,
  jobCompleteFailed,
} from "./consignmentStates.js";

const isEmpty = (obj) => {
  return Object.keys(obj).length == 0;
};

const groupEvents = (eventList, isReverseOrder) => {
  const grouped = {};

  for (let event of eventList) {
    const stateType = getStateType(
      event.eventCode,
      event.reasonCode,
      isReverseOrder,
    );
    if (stateType) {
      if (!grouped[stateType]) {
        grouped[stateType] = [];
      }
      grouped[stateType].push(event);
    }
  }

  return grouped;
};

export function sortAndCheckDeliveries(events, isReverseOrder, orderStatus) {
  const sortedEvents = events?.sort((a, b) => {
    const timestampA = new Date(a.timestamp).getTime();
    const timestampB = new Date(b.timestamp).getTime();
    return timestampA - timestampB;
  });

  let ispickedUp = false;
  let riderIndex = -1;
  let pickupIndex = -1;

  let isRecentPickupFailed = false;
  let isRecentDropFailed = false;

  let isRiderAssigned = false;
  sortedEvents?.forEach((event, index) => {
    if (
      pickupSuccessStates.includes(`${event.eventCode}-${event.reasonCode}`)
    ) {
      pickupIndex = index;
    }
  });

  sortedEvents.forEach((event, index) => {
    if (
      riderAssignedStates.includes(`${event.eventCode}-${event.reasonCode}`)
    ) {
      riderIndex = index;
    }
  });

  if (pickupIndex == sortedEvents.length - 1) {
    ispickedUp = true;
  }

  if (riderIndex == sortedEvents.length - 1) {
    isRiderAssigned = true;
  }

  const filteredSortedList = sortedEvents.filter((item) => {
    return !closedStates.includes(`${item.eventCode}-${item.reasonCode}`);
  });

  filteredSortedList.forEach((item, index) => {
    // const ERCODE =

    const ERCode =
      item?.eventCode + (item?.reasonCode ? `-${item?.reasonCode}` : "");

    if (
      deliveryFailedStates.includes(ERCode) &&
      index == filteredSortedList.length - 1
    )
      isRecentDropFailed = true;
    if (
      pickupFailedStates.includes(ERCode) &&
      index == filteredSortedList.length - 1
    )
      isRecentPickupFailed = true;
  });

  let prevFailedArrayNew = [];
  let currentArrayNew = [];
  let currentArrayLogic = [];
  let prevFailedArrayLogic = [];
  let startPtr = 0;
  let startPtrLogic = 0;
  filteredSortedList.forEach((event, index) => {
    const isRiderAssignedEvent = riderAssignedStates.includes(
      `${event.eventCode}-${event.reasonCode}`,
    );

    const isLastEvent = index == filteredSortedList.length - 1;

    const isTerminalState =
      deliverySuccessStates.includes(
        `${event.eventCode}-${event.reasonCode}`,
      ) ||
      (pickupSuccessStates.includes(`${event.eventCode}-${event.reasonCode}`) &&
        isReverseOrder) ||
      (deliveryFailedStates.includes(
        `${event.eventCode}-${event.reasonCode}`,
      ) &&
        orderStatus == "closed:failed" &&
        isLastEvent) ||
      (pickupFailedStates.includes(`${event.eventCode}-${event.reasonCode}`) &&
        isReverseOrder &&
        orderStatus == "closed:failed" &&
        isLastEvent);

    if (isRiderAssignedEvent && index != 0) {
      const prevFailedEvents = filteredSortedList.slice(startPtrLogic, index);
      startPtrLogic = index;
      prevFailedArrayLogic.push(groupEvents(prevFailedEvents, isReverseOrder));
    }

    if (isLastEvent) {
      const currentEvents = filteredSortedList.slice(startPtrLogic, index + 1);
      currentArrayLogic.push(groupEvents(currentEvents, isReverseOrder));
    }
  });

  const flatcurrentArrayLogic = currentArrayLogic.flat();

  const prevFailedFilteredLogicArray = prevFailedArrayLogic.filter((obj) => {
    return !isEmpty(obj);
  });

  const flatcurrentArrayLogicFiltered = flatcurrentArrayLogic.filter((obj) => {
    return !isEmpty(obj);
  });

  filteredSortedList.forEach((event, index) => {
    const isFailedEvent =
      jobCompleteFailed.includes(`${event.eventCode}-${event.reasonCode}`) ||
      (true &&
        (deliveryFailedStates.includes(
          `${event.eventCode}-${event.reasonCode}`,
        ) ||
          miscStates.FAILURE.includes(
            `${event.eventCode}-${event.reasonCode}`,
          ) ||
          pickupFailedStates.includes(
            `${event.eventCode}-${event.reasonCode}`,
          )));

    if (index == filteredSortedList.length - 1) {
      const currentEvents = filteredSortedList.slice(startPtr, index + 1);
      currentArrayNew.push(groupEvents(currentEvents, isReverseOrder));
    }

    if (isFailedEvent && index != filteredSortedList.length - 1) {
      const prevFailedEvents = filteredSortedList.slice(startPtr, index + 1);
      startPtr = index + 1;
      prevFailedArrayNew.push(groupEvents(prevFailedEvents, isReverseOrder));
    }
  });

  const flatCurrentArray = currentArrayNew.flat();

  const filteredcurrentArrayNew = flatCurrentArray.filter((item) => {
    return !closedStates.includes(`${item.eventCode}-${item.reasonCode}`);
  });

  return {
    ispickedUp,
    prevFailedArrayNew: prevFailedArrayNew,
    prevFailedArrayLogic: prevFailedFilteredLogicArray,
    flatcurrentArrayLogic: flatcurrentArrayLogicFiltered,
    currentArrayNew: filteredcurrentArrayNew[0],
    isRiderAssigned,
    isRecentPickupFailed,
    isRecentDropFailed,
  };
}

function getStateType(eventCode, reasonCode, isReverseOrder) {
  const ERCode = eventCode + (reasonCode ? `-${reasonCode}` : "");
  const {rider, pickup, delivery, misc, reverse} = consignmentStates;

  if (pickup?.includes?.(ERCode)) return "pickup";
  if (rider?.includes?.(ERCode)) return "rider";
  if (delivery?.includes?.(ERCode))
    return isReverseOrder ? "return" : "delivery";
  if (misc?.includes?.(ERCode)) return "misc";
  // if (reverse?.includes?.(ERCode)) return "return"; // Will add proper condition here for return too...
}
